(() => {
  'use strict';

  const VERSION =
    'NMRSTOR ACCOUNT ROUTER V7.5';

  const ROOT_ID =
    'otp-nca-account-modal';


  const mobile =
    window.matchMedia(
      '(max-width: 640px)'
    );


  const tablet =
    window.matchMedia(
      '(min-width: 641px) and (max-width: 1024px)'
    );

  const touchTablet =
    window.matchMedia(
      '(min-width: 641px) and (max-width: 1366px) and (pointer: coarse)'
    );


  function getDevice() {

    if (mobile.matches) {
      return 'mobile';
    }


    if (
      tablet.matches ||
      touchTablet.matches
    ) {
      return 'tablet';
    }


    return 'desktop';

  }


  function getLocale() {

    const html =
      document.documentElement;


    const lang =
      String(
        html.lang ||
        window.Shopify?.locale ||
        ''
      )
        .trim()
        .toLowerCase();


    if (
      lang.startsWith('ar') ||
      html.dir === 'rtl' ||
      /^\/ar(?:\/|$)/i.test(
        location.pathname
      )
    ) {

      return 'ar';

    }


    return 'en';

  }


  function setData(
    node,
    key,
    value
  ) {

    if (!node) {
      return;
    }


    if (
      node.dataset[key] !==
      value
    ) {

      node.dataset[key] =
        value;

    }

  }


  function sync() {

    const device =
      getDevice();


    const locale =
      getLocale();


    const html =
      document.documentElement;


    setData(
      html,
      'nmrAccountDevice',
      device
    );


    setData(
      html,
      'nmrAccountLocale',
      locale
    );


    const root =
      document.getElementById(
        ROOT_ID
      );


    if (root) {

      setData(
        root,
        'nmrAccountDevice',
        device
      );


      setData(
        root,
        'nmrAccountLocale',
        locale
      );

    }

  }


  let queued =
    false;


  function queueSync() {

    if (queued) {
      return;
    }


    queued =
      true;


    requestAnimationFrame(
      () => {

        queued =
          false;

        sync();

      }
    );

  }


  sync();


  if (
    typeof mobile.addEventListener ===
    'function'
  ) {

    mobile.addEventListener(
      'change',
      queueSync
    );


    tablet.addEventListener(
      'change',
      queueSync
    );

    touchTablet.addEventListener(
      'change',
      queueSync
    );

  }
  else {

    mobile.addListener(
      queueSync
    );


    tablet.addListener(
      queueSync
    );

    touchTablet.addListener(
      queueSync
    );

  }


  window.addEventListener(
    'orientationchange',
    queueSync,
    {
      passive:
        true
    }
  );


  if (document.body) {

    const observer =
      new MutationObserver(
        records => {

          const rootAppeared =
            records.some(
              record =>
                [...record.addedNodes]
                  .some(
                    node =>
                      node instanceof Element &&
                      (
                        node.id === ROOT_ID ||
                        node.querySelector?.(
                          '#' + ROOT_ID
                        )
                      )
                  )
            );


          if (rootAppeared) {
            queueSync();
          }

        }
      );


    observer.observe(
      document.body,
      {
        childList:
          true,

        subtree:
          true
      }
    );

  }

})();